import { useMatch } from 'react-router-dom';

const useFarmIdParam = () => {
  const farmMatch = useMatch('/farms/:farmId');

  return farmMatch?.params.farmId || '';
};

export default useFarmIdParam;
